import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============== Contact API ==============

export const submitContactForm = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

export const getContactRequests = async () => {
  const response = await api.get('/contact');
  return response.data;
};

export const markContactAsRead = async (id) => {
  const response = await api.patch(`/contact/${id}/read`);
  return response.data;
};

export const deleteContactRequest = async (id) => {
  await api.delete(`/contact/${id}`);
};

// ============== Publications API ==============

export const getPublications = async (publishedOnly = true) => {
  const response = await api.get('/publications', {
    params: { published_only: publishedOnly },
  });
  return response.data;
};

export const getPublication = async (id) => {
  const response = await api.get(`/publications/${id}`);
  return response.data;
};

export const createPublication = async (data) => {
  const response = await api.post('/publications', data);
  return response.data;
};

export const updatePublication = async (id, data) => {
  const response = await api.put(`/publications/${id}`, data);
  return response.data;
};

export const deletePublication = async (id) => {
  await api.delete(`/publications/${id}`);
};

// ============== Admin API ==============

export const adminLogin = async (password) => {
  const response = await api.post('/admin/login', { password });
  const { access_token } = response.data;
  localStorage.setItem('admin_token', access_token);
  return access_token;
};

export const verifyAdminToken = async () => {
  try {
    const response = await api.get('/admin/verify');
    return response.data.valid;
  } catch {
    localStorage.removeItem('admin_token');
    return false;
  }
};

export const adminLogout = () => {
  localStorage.removeItem('admin_token');
};

export default api;
